<template>
  <CCard>
    <CCardHeader class="p-2 font-weight-bold" style="line-height: 2">
      포화수증기량
    </CCardHeader>
    <CCardBody class="p-2" v-if="emptyFlag"> 데이터 없음</CCardBody>
    <CCardBody class="p-2" :class="emptyFlag ? 'd-none' : ''">
      <img
        :src="app.getUrl('img/vd.png')"
        style="height: 100%; width: 100%; object-fit: contain"
      />
    </CCardBody>
  </CCard>
</template>

<script>
import store from "@/store";
import MixinsInEnvSensor from "@/mixins/in-env-sensor";

export default {
  name: "SaturatedWaterVaporComponent",
  components: {},
  mixins: [MixinsInEnvSensor()],
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          initFlag: false,
          inEnvList: [],
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      emptyFlag: true,
    };
  },
  mounted() {
    this.init();
    this.emptyFlag = false;
  },
  watch: {
    "properties.initFlag"(val) {
      this.properties.initFlag = false;
      if (val) {
        this.init();
      }
    },
    "properties.inEnvList"() {
      this.redraw();
    },
  },
  methods: {
    init() {},
    redraw() {},
  },
};
</script>
